package com.patronat.top.client.presentation.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.patronat.top.client.platform.ClientBackHandler
import com.patronat.top.dto.UserRole
import org.koin.compose.koinInject

@Composable
fun ClientAuthRoute(
    onContinueWithoutAccount: () -> Unit = {},
    onAuthenticated: (UserRole) -> Unit = {}
) {
    val viewModel: ClientAuthViewModel = koinInject()
    val state by viewModel.viewState.collectAsState()

    LaunchedEffect(viewModel) {
        viewModel.effect.collect { effect ->
            when (effect) {
                ClientAuthEffect.ContinueWithoutAccount -> onContinueWithoutAccount()
                is ClientAuthEffect.NavigateToHome -> onAuthenticated(effect.role)
            }
        }
    }

    ClientBackHandler(
        enabled = state.step != ClientAuthStep.GetStarted,
        onBack = { viewModel.onEvent(ClientAuthEvent.OnBackClicked) }
    )

    ClientAuthScreen(
        state = state,
        onEvent = viewModel::onEvent
    )
}
